import React, { useState, useEffect, useContext } from 'react';
import { getMentorInsights } from '../../../api/mentor_insights.js';
import { getMentorInsightsExport } from '../../../api/mentor_insights.js';
import ExportButton from '../../ui_kit/buttons/export_button';
import Context from '../../../utils/context';
import TableWithPagination from '../../ui_kit/tables';

import styles from './index.module.css';

const HIDE_MENTOR_EMAIL_ACCOUNT_SLUGS = ['bylvay'];

const MentorInsights = () => {
  const [patientPartners, setPatientPartners] = useState([]);
  const context = useContext(Context);
  const currentUser = context.auth.getCurrentUser();
  const isMobile = context.viewport.getIsMobile();
  const accountSlug = context.auth.currentAccount()?.slug;
  const hideMentorEmail = HIDE_MENTOR_EMAIL_ACCOUNT_SLUGS.includes(accountSlug);

  const sortableHeaders = [
    'Total patient conversations',
    'Avg. rating',
    'Total number of messages',
    'Accepts Calls',
    'Calls accepted',
    'Calls completed',
    'Mentor unreachable',
    'Patient unreachable',
    'Status',
  ];
  const allHeaders = [
    'Mentor Name',
    'Mentor Email',
    'Total patient conversations',
    'Avg. rating',
    'Total number of messages',
    'Accepts Calls',
    'Calls accepted',
    'Calls completed',
    'Mentor unreachable',
    'Patient unreachable',
    'Status',
  ];

  const allKeys = [
    'name',
    'email',
    'num_patient_connections',
    'average_rating',
    'total_messages_count',
    'accepts_calls',
    'accepted_calls_count',
    'completed_calls_count',
    'mentor_unreachable_calls_count',
    'patient_unreachable_calls_count',
    'inactive',
  ];

  const emailColumnIndex = allKeys.indexOf('email');
  const headers = hideMentorEmail ? allHeaders.filter((_, i) => i !== emailColumnIndex) : allHeaders;
  const keys = hideMentorEmail ? allKeys.filter((_, i) => i !== emailColumnIndex) : allKeys;

  useEffect(() => {
    let mounted = true;

    const loadData = async () => {
      try {
        new Promise((resolve, reject) => {
          getMentorInsights({}, (data) => {
            if (mounted) {
              try {
                setPatientPartners(data);
                resolve();
              } catch (error) {
                reject(error);
              }
            }
          });
        });
      } catch (error) {
        console.error('Error loading data:', error);
      }
    };

    loadData();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className='container marg-bottom-50'>
      <div className='row'>
        <h1 className={`${styles.header} col-lg-6`}>Mentor Insights</h1>
      </div>

      <div className='row'>
        <h1 className={`${styles.small_header} col-lg-6`}>Mentor Health</h1>

        <ExportButton requestExport={getMentorInsightsExport} params={{}} />
      </div>

      <div className='row'>
        <div className='col-md-6'>
          <div className='content_container'>
            {patientPartners.length > 0 ? (
              <div className={`${styles.blue_text} row justify-content-center`}>
                {patientPartners.reduce((sum, pp) => (pp.inactive ? sum : sum + 1), 0)}
              </div>
            ) : (
              <div className={`${styles.blue_text} row justify-content-center`}>no data</div>
            )}
            <p className='row justify-content-center'>active mentors</p>
          </div>
        </div>

        <div className='col-md-6'>
          <div className='content_container'>
            {patientPartners.length > 0 ? (
              <div className={`${styles.blue_text} row justify-content-center`}>
                {patientPartners.reduce((sum, pp) => sum + pp.total_messages_count, 0)}
              </div>
            ) : (
              <div className={`${styles.blue_text} row justify-content-center`}>no data</div>
            )}
            <p className='row justify-content-center'>total messages sent</p>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-lg-12'>
          <TableWithPagination
            headers={headers}
            sortableHeaders={sortableHeaders}
            objects={patientPartners}
            keys={keys}
            isMobile={isMobile}
            perPage={50}
            formatting={{
              average_rating: (value) => (value === 0 ? 'N/A' : value),
              accepts_calls: (value) => (value ? 'Yes' : 'No'),
              inactive: (value) => (value ? 'Inactive' : 'Active'),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MentorInsights;
